module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[50]171.4367a32.woff2";